/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useState } from 'react';
import PropTypes from 'prop-types';

// @mui material components
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import InputAdornment from '@mui/material/InputAdornment';
import Grid from '@mui/material/Grid';

// Material Dashboard 2 PRO React components
import MDInput from 'components/MDInput';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import * as Func from 'services/Function';

function BankNote({ parent, callback }) {
  const [attr, setAttr] = useState(parent);
  const [focus, setFocus] = useState(false);

  const send = () => {
    callback(attr);
  };

  return (
    <MDBox className='card' sx={{ overflow: 'hidden' }}>
      <CardMedia
        sx={{ height: 170, m: 0, borderRadius: 0 }}
        image={parent.image}
        title={parent.name}
      />
      <CardContent sx={{ px: 2, pt: 3, fontSize: 15, color: '#666666', fontWeight: 100 }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <MDTypography>ธนบัตร</MDTypography>
          </Grid>
          <Grid item xs={6} align='right'>
            <MDTypography>{parent.name}</MDTypography>
          </Grid>
          <Grid item xs={12}>
            <MDBox
              noValidate
              component='form'
              role='form'
              onSubmit={(e) => {
                e.preventDefault();
                send();
              }}
            >
              <MDInput
                value={attr.quantity === '0' ? '' : attr.quantity}
                onChange={(e) => {
                  const count = e.target.value * 1;
                  const bank = parent.code * 1;
                  const total = count * bank;
                  setAttr({ ...attr, quantity: count, total: total });
                }}
                onFocus={(e) => {
                  setFocus(true);
                  e.target.select();
                }}
                onBlur={() => {
                  if (focus) {
                    setFocus(false);
                    send();
                  }
                }}
                type='number'
                variant='standard'
                fullWidth
                InputProps={{
                  startAdornment: <InputAdornment position='start'>จำนวน :</InputAdornment>,
                  endAdornment: <InputAdornment position='end'>ใบ</InputAdornment>,
                  inputProps: {
                    placeholder: '0',
                    maxLength: 10,
                    className: 'text-right',
                    autoComplete: 'off',
                  },
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={6}>
            <MDTypography>รวม</MDTypography>
          </Grid>
          <Grid item xs={6} align='right'>
            <MDTypography>{Func.numberDisplay(attr.total)} บาท</MDTypography>
          </Grid>
        </Grid>
      </CardContent>
    </MDBox>
  );
}

BankNote.propTypes = {
  parent: PropTypes.shape({
    id: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    quantity: PropTypes.string.isRequired,
    total: PropTypes.string.isRequired,
  }).isRequired,
  callback: PropTypes.func.isRequired,
};

export default BankNote;
